<template>
  <WebChapterTemplate
    page-title="《治学例话》系列"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section">
      <article class="content-card">
        <h2 class="section-title">《治学例话》系列</h2>
        <p class="body-text">
          2013 年，中国社会科学院新闻与传播研究所开展了首届全国新闻传播学优秀论文遴选活动，《治学例话——全国新闻传播学优秀论文遴选》荟萃了这一活动的成果，是我国第一本综合评价新闻传播学治学佳作的文集。该系列成果第一辑被中国社会科学出版社评为“2015 年度好书”。每年出版一辑，目前已出版五辑。
        </p>
        <figure class="book-gallery">
          <img :src="images.zhixuelihuaBooks" alt="《治学例话》系列图书书影" />
          <figcaption>《治学例话》系列图书书影</figcaption>
        </figure>
      </article>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuZhixuelihuaxilie',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        zhixuelihuaBooks: require('./assets/zhixuelihua-books.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.content-card {
  padding: 28px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(247, 240, 230, 0.72), rgba(255, 255, 255, 0) 46%),
    linear-gradient(180deg, rgba(255, 251, 246, 0.98), rgba(255, 255, 255, 1));
  border: 1px solid rgba(179, 145, 101, 0.18);
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 24px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.book-gallery {
  margin: 0;
}

.book-gallery img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 10px 28px rgba(45, 33, 16, 0.08);
}

.book-gallery figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 768px) {
  .content-card {
    padding: 18px;
  }
}
</style>
